import { Fetch } from "../utils/fetch";
/**
 * Sample操作封装
 */
export class GroceryMarketShareApi {
  //Excel素材上传
  uploadExcelUrl = process.env.BASE_API + "MarketReportFile/ReceiveExcel";
  //Pdf素材上传
  uploadPdfUrl = process.env.BASE_API + "MarketReportFile/ReceivePdf";
  /**
   * 保存数据
   * @param {SampleForm} data 保存数据对象
   */
}
